<template>
  <el-dialog
    title="添加单票用户"
    :visible.sync="dialogVisible"
    width="500px"
    :before-close="handleClose"
    @close="handleClose"
  >
    <el-form
      ref="createForm"
      :model="form"
      :rules="rules"
      label-width="150px"
      v-loading="loading"
    >
      <el-form-item label="平台名称：" prop="appName">
        <el-select
          v-model="form.appName"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键字搜索"
          :remote-method="getAppList"
          :loading="appLoading"
          style="width: 100%"
          @change="handleAppChange"
        >
          <el-option
            v-for="item in appOptions"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="渠道：" prop="channelName">
        <el-select
          v-model="form.channelName"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键字搜索"
          :remote-method="getChannelList"
          :loading="channelLoading"
          style="width: 100%"
          :disabled="!form.appName"
        >
          <el-option
            v-for="item in channelOptions"
            :key="item.id"
            :label="item.realname + '(' + item.alias + ')'"
            :value="item.realname"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="产品名称：" prop="productName">
        <el-select
          v-model="form.productName"
          filterable
          remote
          reserve-keyword
          placeholder="请输入关键字搜索"
          :remote-method="getProductList"
          :loading="productLoading"
          style="width: 100%"
        >
          <el-option
            v-for="item in productOptions"
            :key="item.id"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="手机号/用户名：" prop="mobile">
        <el-input
          v-model.trim="form.mobile"
          placeholder="请输入手机号或用户名"
          maxlength="64"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAppList, getChannelList, getProductList, createSingleUser } from '@/api/member'

export default {
  name: 'CreateSingleUser',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      loading: false,
      submitting: false,
      appLoading: false,
      channelLoading: false,
      productLoading: false,
      form: {
        appName: '',
        appId: '',
        channelName: '',
        channelId: '',
        productName: '',
        productId: '',
        mobile: ''
      },
      rules: {
        appName: [
          { required: true, message: '请选择平台名称', trigger: 'change' }
        ],
        channelName: [
          { required: true, message: '请选择渠道', trigger: 'change' }
        ],
        productName: [
          { required: true, message: '请选择产品名称', trigger: 'change' }
        ],
        mobile: [
          { required: true, message: '请输入手机号或用户名', trigger: 'blur' }
        ]
      },
      appOptions: [],
      channelOptions: [],
      productOptions: [],
      allApps: [],
      allChannels: [],
      allProducts: []
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal) {
        this.initData()
      }
    }
  },
  methods: {
    // 初始化数据
    async initData() {
      this.resetForm()
      await this.getAllApps()
      await this.getAllProducts()
    },

    // 重置表单
    resetForm() {
      this.$refs.createForm && this.$refs.createForm.resetFields()
      this.form = {
        appName: '',
        appId: '',
        channelName: '',
        channelId: '',
        productName: '',
        productId: '',
        mobile: ''
      }
    },

    // 获取所有平台列表
    async getAllApps() {
      try {
        const res = await getAppList()
        if (res.err_code === 0) {
          this.allApps = res.rows || []
          this.appOptions = res.rows || []
        }
      } catch (error) {
        console.error('获取平台列表失败:', error)
      }
    },

    // 获取平台列表（搜索）
    async getAppList(query) {
      if (query) {
        this.appLoading = true
        try {
          const res = await getAppList()
          if (res.err_code === 0) {
            this.appOptions = (res.rows || []).filter(item => 
              item.name.toLowerCase().includes(query.toLowerCase())
            )
          }
        } catch (error) {
          console.error('搜索平台失败:', error)
        } finally {
          this.appLoading = false
        }
      } else {
        this.appOptions = this.allApps
      }
    },

    // 平台选择变化
    handleAppChange(val) {
      const selectedApp = this.allApps.find(app => app.name === val)
      if (selectedApp) {
        this.form.appId = selectedApp.id
        // 清空渠道选择
        this.form.channelName = ''
        this.form.channelId = ''
        // 获取对应渠道列表
        this.getChannelListByApp(selectedApp.id)
      }
    },

    // 根据平台获取渠道列表
    async getChannelListByApp(appId) {
      try {
        const res = await getChannelList({ app_id: appId })
        if (res.err_code === 0) {
          this.allChannels = res.rows || []
          this.channelOptions = res.rows || []
        }
      } catch (error) {
        console.error('获取渠道列表失败:', error)
      }
    },

    // 获取渠道列表（搜索）
    async getChannelList(query) {
      if (query && this.form.appId) {
        this.channelLoading = true
        try {
          const res = await getChannelList({ app_id: this.form.appId })
          if (res.err_code === 0) {
            this.channelOptions = (res.rows || []).filter(item => 
              (item.name + item.alias).toLowerCase().includes(query.toLowerCase())
            )
          }
        } catch (error) {
          console.error('搜索渠道失败:', error)
        } finally {
          this.channelLoading = false
        }
      } else {
        this.channelOptions = this.allChannels
      }
    },

    // 渠道选择变化
    handleChannelChange(val) {
      const selectedChannel = this.allChannels.find(channel => channel.name === val)
      if (selectedChannel) {
        this.form.channelId = selectedChannel.id
      }
    },

    // 获取所有产品列表
    async getAllProducts() {
      try {
        const res = await getProductList()
        if (res.err_code === 0) {
          this.allProducts = res.rows || []
          this.productOptions = res.rows || []
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
      }
    },

    // 获取产品列表（搜索）
    async getProductList(query) {
      if (query) {
        this.productLoading = true
        try {
          const res = await getProductList()
          if (res.err_code === 0) {
            this.productOptions = (res.rows || []).filter(item => 
              item.name.toLowerCase().includes(query.toLowerCase())
            )
          }
        } catch (error) {
          console.error('搜索产品失败:', error)
        } finally {
          this.productLoading = false
        }
      } else {
        this.productOptions = this.allProducts
      }
    },

    // 产品选择变化
    handleProductChange(val) {
      const selectedProduct = this.allProducts.find(product => product.name === val)
      if (selectedProduct) {
        this.form.productId = selectedProduct.id
      }
    },

    // 关闭对话框
    handleClose() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },

    // 提交表单
    handleSubmit() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          // 查找选中项的ID
          const selectedApp = this.allApps.find(app => app.name === this.form.appName)
          const selectedChannel = this.allChannels.find(channel => channel.realname === this.form.channelName)
          const selectedProduct = this.allProducts.find(product => product.name === this.form.productName)
          
          if (!selectedApp) {
            this.$message.warning('请选择有效的平台')
            return
          }
          
          if (!selectedChannel) {
            this.$message.warning('请选择有效的渠道')
            return
          }
          
          if (!selectedProduct) {
            this.$message.warning('请选择有效的产品')
            return
          }
          
          this.submitting = true
          try {
            const params = {
              type: 2,
              mobile: this.form.mobile,
              app_id: selectedApp.id,
              channel_id: selectedChannel.id,
              product_id: selectedProduct.id
            }
            
            const res = await createSingleUser(params)
            if (res.err_code === 0) {
              this.$message.success('保存成功')
              this.$emit('success')
              this.handleClose()
            } else {
              this.$message.error(res.err_msg || '保存失败')
            }
          } catch (error) {
            console.error('创建用户失败:', error)
            this.$message.error('保存失败')
          } finally {
            this.submitting = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.dialog-footer {
  text-align: center;
}
</style>